import modalConfirmation from '../../shared/components/modal-response/modal-response.view.html';
import modalQuantityCart from '../modal-quantity-cart/modal-quantity-cart.view.html';
import modalConfirmationCart from '../modal-confirmation/modal-confirmation.view.html';

let inject = [
    '$scope',
    'CompareProductsService',
    '$state',
    '$rootScope',
    'SharedService',
    '$timeout',
    'ngAuthSettings',
    'CartService',
    'SessionService',
    'NgTableParams',
    '$uibModal',
    'CategoryService',
    '$stateParams'
];

class CompareProductsController {
    constructor($scope,
                CompareProductsService,
                $state,
                $rootScope,
                SharedService,
                $timeout,
                ngAuthSettings,
                CartService,
                SessionService,
                NgTableParams,
                $uibModal,
                CategoryService,
                $stateParams) {
        this.$state = $state;
        this.SessionService = SessionService;
        this.ngAuthSettings = ngAuthSettings;
        this.CartService = CartService;
        this.NgTableParams = NgTableParams;
        this.CategoryService = CategoryService;
        this.$stateParams = $stateParams;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.CompareProductsService = CompareProductsService;
        this.$uibModal = $uibModal;
        this.SharedService = SharedService;
        this.idCategory = this.$stateParams.categoryId;
        this.idsProductsToCompare = this.$stateParams.products;

        this.dataCart = {};
        this.dataProducs = {};

        this.productItems = {};
    }

    $onInit() {
        this.getAttributesCategoryToCompare();
    }

    getAttributesCategoryToCompare() {
        this.CategoryService.getAttributesCategory(this.idCategory).then(response => {
            this.categoryAttributesToCompare = response;
            this.getProductToCompare();
        }).catch(reason => {
            console.log(reason);
            // this.$state.go('404');
        });
    }

    getProductToCompare() {
        let userId = '';
        try {
            userId = this.shCtrl.globals.currentUser.userId;
        }
        catch (e) {
        }
        this.CompareProductsService.getProductToCompare(this.idsProductsToCompare, userId).then(response => {
            this.productsToCompare = response;
            // Validate attributes count in products
            let productsToCompareQuantity = response.length;
            let productsToCompareDummy = [];
            this.categoryAttributesToCompare.forEach(attribute => {
                let group = attribute.group;
                let countAttribute = 0;
                this.productsToCompare.forEach(product => {
                    angular.forEach(product.attributesDetail, (attributeProduct) => {
                        if (attributeProduct.name === group) {
                            countAttribute++;
                        }
                    })
                });
                if (countAttribute) {
                    productsToCompareDummy.push(attribute);
                }
            });

            this.categoryAttributesToCompare = productsToCompareDummy;
        }).catch(reason => {

        })
    }

    setItemToAddToCart(product) {
        product.id = parseInt(product.id);
        let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalQuantityCart,
            controller: 'ModalQuantityCartController',
            controllerAs: 'mdCtrl',
            size: 'sm',
            resolve: {
                product: () => product
            }
        });
        modalInstance.result.then(result => {
            if (result.product.id && result.quantity) {
                let userId = '', cart = null;
                try {
                    userId = this.shCtrl.globals.currentUser.userId;
                } catch (e) {
                }
                try {
                    cart = this.shCtrl.cart;
                } catch (e) {
                }
                this.CartService.addItemToCart(result.product, result.quantity, null, null, userId, cart).then(response => {

                    if (!response.error) {
                        // this.$scope.$emit('onUpdateCart');
                        // let modalInstance2 = this.$uibModal.open({
                        //   animation: true,
                        //   template: modalConfirmationCart,
                        //   controller : 'ModalConfirmationController',
                        //   controllerAs : 'mdCtrl',
                        //   size: 'lg',
                        //   resolve : {
                        //     product : () => product
                        //   }
                        // });

                        this.dataCart = {};
                        this.dataProducs = {};
                        this.modalConfirmation(product, result.quantity);

                    } else {
                        let options = {
                            title: '',
                            isHtml: true,
                            content: response.message,
                            size: '',
                            showBottonCancel: false,
                            textActionCancel: '',
                            textAction: 'Aceptar'
                        };
                        this.messageResponse(options);
                    }
                }).catch(reason => {
                    let options = {
                        title: '',
                        isHtml: false,
                        content: reason,
                        size: '',
                        showBottonCancel: false,
                        textActionCancel: '',
                        textAction: 'Aceptar'
                    };
                    this.messageResponse(options);
                });
            }
        }).catch(error => {

        });
    }

    delProductToArray(productId) {
        if (productId) {
            this.productsToCompare = this.productsToCompare.filter(val => val.id !== productId);
            if (!this.productsToCompare.length) {
                this.$state.go('home.categoryIdProducts', {idCategory: this.idCategory});
            }
        }
    }

    messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
        let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalConfirmation,
            controller: 'ModalResponseController',
            controllerAs: 'mdCtrl',
            size: options.size,
            resolve: {
                modalOptions: () => options
            }
        });
        modalInstance.result.then(() => {
            if (callAcept) {
                callback();
            }
        }).catch(reason => {
            if (callCancel) {
                callbackCancel();
            }
        });
    }

    modalConfirmation(products, quantity) {

        this.productAdded = products;
        this.productAdded.image = products.imagesDetail[0].path + products.imagesDetail[0].image;
        this.productAdded.price = products.itemPrice;
        this.productAdded.discount = products.discountValue;
        this.productAdded.ivaValue = products.taxValue;
        this.productAdded.quantity = quantity;
        this.productAdded.total = (products.itemPrice - products.discountValue + products.taxValue) * quantity;

        $('#productList').modal('toggle');

        this.$scope.$emit('onUpdateCart', 'modalResponseItems');
    }

}

CompareProductsController.$inject = inject;

export default CompareProductsController;




/** WEBPACK FOOTER **
 ** C:/Bitnami/wampstack-7.1.31-0/apache2/htdocs/toning/B2C/www/components/catalog/compare-products/compare-products.controller.js
 **/